import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const vuexPersist = new VuexPersist({
  key: 'stamps-home',
  storage: window.localStorage,
});

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    badges: [],
    categories: [],
  },
  mutations: {
    setBadges(s, badges) {
      s.badges = badges;
    },
    setCategories(s, categories) {
      s.categories = categories;
    },
  },
  actions: {
  },
  modules: {
  },
});
